import { gql, QueryHookOptions, QueryResult } from '@apollo/client';

import { useAPIQuery } from 'Api/handler';

import { Country, Status, Toolbox } from 'Types';

export type GetToolboxResponse = {
  toolbox: {
    transportations: Toolbox[];
    constraints: Toolbox[];
    handlingUnits: Toolbox[];
    reasons: Toolbox[];
    status: Status[];
    countries: Country[];
  };
};

type GetToolboxVariables = {
  modes: string[];
};

export const useGetToolbox = (
  options?: QueryHookOptions<GetToolboxResponse, GetToolboxVariables>,
): QueryResult<GetToolboxResponse, GetToolboxVariables> => {
  return useAPIQuery(GET_TOOLBOX, options);
};

export const GET_TOOLBOX = gql`
  query GetToolbox($modes: [String]!) {
    toolbox(modes: $modes) {
      transportations {
        id
        value
        toolboxId
      }
      constraints {
        id
        value
        toolboxId
      }
      handlingUnits {
        id
        value
        toolboxId
      }
      reasons {
        id
        value
        toolboxId
      }
      status {
        id
        value
        label
        statusId
      }
      countries {
        id
        code
      }
    }
  }
`;
